import { render, staticRenderFns } from "./AssignmentRole.vue?vue&type=template&id=748b9a4e&scoped=true&"
import script from "./AssignmentRole.vue?vue&type=script&lang=js&"
export * from "./AssignmentRole.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentRole.vue?vue&type=style&index=0&id=748b9a4e&scoped=true&lang=css&"
import style1 from "./AssignmentRole.vue?vue&type=style&index=1&id=748b9a4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748b9a4e",
  null
  
)

export default component.exports